

















import Vue from 'vue'
import { FilterItems } from '@/types/service-response'
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'

interface ComponentData {
  selectedItem: { planningGroup: number, planningGroupName: string } | undefined
  selectRules: Array<(v: string) => string | boolean>
}

interface Payload {
  name: string
  value: string
  label: string
}

export default Vue.extend({
  name: 'ReportingPlanningGroupSelect',

  props: {
    focus: Boolean,
    name: String,
    label: String,
    items: {
      type: Array as () => Array<FilterItems>
    },
    isRequired: Boolean,
    isValid: Boolean,
    filteredPlanningGroupList: Array as () => PlanningGroup[]
  },

  data (): ComponentData {
    return {
      selectedItem: undefined,
      selectRules: [
        (v) => {
          if (this.isRequired) {
            return !!v || this.$t('reportingFilter.valueIsRequired').toString()
          } else {
            return true
          }
        }
      ]
    }
  },

  watch: {
    isValid (newVal: boolean): void {
      if (newVal === true) {
        const form: any = this.$refs['form']
        form.validate()
      }
    },

    filteredPlanningGroupList (newVal: PlanningGroup[]): void {
      if(newVal) {
        this.selectedItem = undefined
        this.onSelectChange()
      }
    }
  },

  methods: {
    onSelectChange (): void {
      if (this.name && this.selectedItem && this.selectedItem.planningGroupName) {
        let payload: Payload = { name: this.name, value: this.selectedItem.planningGroup.toString(), label: this.selectedItem.planningGroupName }
        this.$emit('onSelectChange', payload)
      } else {
        let payload: Payload = { name: this.name, value: '', label: '' }
        this.$emit('onSelectChange', payload)
      }
    }
  },

  created (): void {
    if(this.focus) {
      setTimeout(() => {
        const field: any = this.$refs['field']
        if (field) {
          field.focus()
        }
      }, 0)
    }
  }

})
